import React from 'react'
import {Alert} from 'react-bootstrap'

const AppLoaderErrorIndicator: React.FunctionComponent = () => (
  <Alert bsStyle="danger">
    <p>Failed loading, please reload and try again, or contact support.</p>
  </Alert>
)

export default AppLoaderErrorIndicator
